import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Typography, Box, Button } from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import PageCover from "../Components/Shared/PageCover";
import newsCover from "../Components/Assets/Images/newsCover.jpg";
import newsData from "../Components/Shared/NewsData";

const News = () => {
  return (
    <>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <PageCover
          image={newsCover}
          title="News & Events"
          subtitle="Updates, Announcements, and Stories from Our Journey"
        />
      </motion.div>

      <Box
        className="news-section"
        style={{ backgroundColor: "#f0f8ff", padding: "4rem 0" }}
      >
        <Container>
          <Row className="mb-5">
            <Col lg={4} className="mb-2">
              <motion.div
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <Typography
                  variant="h2"
                  component="h2"
                  sx={{ fontWeight: 700 }}
                >
                  Shankh Air in <br /> News
                </Typography>
              </motion.div>
            </Col>
            <Col lg={8} className="mb-2">
              <motion.div
                initial={{ x: 100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                <Typography
                  variant="body1"
                  component="p"
                  sx={{ color: "#242323" }}
                >
                  At Shankh Air, we are actively laying the groundwork to bring
                  affordable air travel to more regions across the country. From
                  building operational capabilities to shaping reliable service
                  frameworks, our focus is firmly on preparation, precision, and
                  long-term impact. Every step we take today is aimed at making
                  flying accessible, dependable, and sustainable tomorrow. As
                  our journey progresses, we will continue to share updates,
                  milestones, and behind-the-scenes developments as we move
                  closer to taking to the skies.
                </Typography>
              </motion.div>
            </Col>
          </Row>
          <Row
            className="mb-5"
            style={{
              backgroundColor: "#fff",
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset",
              padding: "60px 25px",
              borderRadius: "8px",
            }}
          >
            {newsData.map((news) => (
              <Col lg={4} md={6} sm={12} key={news.id} className="mb-4">
                <motion.div
                  initial={{ y: 60, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true }}
                >
                  <Card className="h-100 news-card">
                    <Card.Img
                      variant="top"
                      src={news.image}
                      className="img-fluid news-img"
                      alt={news.title}
                    />

                    <Card.Body>
                      {/* Clickable heading */}
                      <Typography
                        variant="h6"
                        component={Link}
                        to={`/news/${news.slug}`}
                        sx={{
                          fontWeight: 600,
                          textDecoration: "none",
                          marginBottom: "20px",
                          display: "block",
                          color: "inherit",
                          fontSize: "22px",
                          "&:hover": { color: "#f3bb13" },
                        }}
                      >
                        {news.title}
                      </Typography>

                      {/* Small excerpt */}
                      <Typography
                        variant="body2"
                        sx={{ marginTop: "6px", color: "text.secondary" }}
                      >
                        {news.content.substring(0, 100)}...
                      </Typography>

                      {/* Date */}
                      <Typography
                        variant="caption"
                        sx={{ display: "block", marginTop: "10px" }}
                      >
                        {news.date}
                      </Typography>

                      {/* Video info */}
                      {news.videoUrl && (
                        <Typography variant="caption" sx={{ display: "block" }}>
                          🎥 Video available
                        </Typography>
                      )}

                      {/* Video link */}
                      {news.videoUrl && (
                        <Button
                          component={Link}
                          to={`/news/${news.slug}`}
                          className="cta no-moreBtn"
                          sx={{ mt: "22px", mb: "10px" }}
                        >
                          <Typography variant="body1" component="span">
                            Know More
                          </Typography>

                          <svg width="15px" height="10px" viewBox="0 0 13 10">
                            <path d="M1,5 L11,5"></path>
                            <polyline points="8 1 12 5 8 9"></polyline>
                          </svg>
                        </Button>
                      )}
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default News;
